import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { trackByValue } from '@y42/angular/util';
import { ColumnTypeEnum, OperatorEnum } from '@y42/json-schema';
import { SelectOption } from '@y42/util/select-option';
import { OperationInputFormService } from '../../operation-input-form.service';

@Component({
  selector: 'y42-operation-input-select[columnType]',
  templateUrl: './operation-input-select.component.html',
  styleUrls: ['../operation-input-shared.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OperationInputSelectComponent {
  constructor(private readonly formService: OperationInputFormService) {}

  readonly trackByValue = trackByValue;

  @Input()
  columnType!: ColumnTypeEnum;

  @Input() predefinedValues: string[] | null = null;

  @Output()
  loadAutoProposal: EventEmitter<void> = new EventEmitter();

  @Input()
  operatorOptions?: Array<SelectOption<OperatorEnum>>;

  readonly operationsFormArray = this.formService.operationsFormArray;
}
